import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

// export default new Vuetify({
//    theme: {
//       themes: {
//          dark: {
//             primary: '#843fff',
//             secondary: '#b0bec5',
//             accent: '#7154FF',
//             error: '#b71c1c',
//          },
//       }
//
//
//    }
// });


export default new Vuetify({
   theme: {
      dark: true,
      themes: {
         light: {
            primary: '#b53491',
            secondary: '#b0bec5',
            accent: '#8c9eff',
            error: '#b71c1c',
         },

         dark: {
            primary: '#6500E9',
            secondary: '#b0bec5',
            accent: '#8c9eff',
            error: '#ff1a06',
         },
      },
   },
})
